import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

const deleteCoursePricingPolicy = (
  course_id: string,
  version: number,
  policyId: string
) => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL =
      routes.COURSE +
      course_id +
      '/' +
      version +
      '/pricing-policies/' +
      policyId
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }

    AxiosClient.delete(URL, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
export default deleteCoursePricingPolicy
